module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "container"
  }, [_c('div', {
    staticClass: "flex"
  }, [_c('router-link', {
    attrs: {
      "to": "/"
    }
  }, [_c('h4', [_c('svg', {
    attrs: {
      "fill": "#FFFFFF",
      "height": "24",
      "viewBox": "0 0 24 16",
      "width": "24",
      "xmlns": "http://www.w3.org/2000/svg"
    }
  }, [_c('path', {
    attrs: {
      "d": "M0 0h24v24H0z",
      "fill": "none"
    }
  }), _vm._v(" "), _c('path', {
    attrs: {
      "d": "M20 11H7.83l5.59-5.59L12 4l-8 8 8 8 1.41-1.41L7.83 13H20v-2z"
    }
  })]), _vm._v("\n        Play the game\n      ")])])], 1), _vm._v(" "), _c('h1', [_vm._v("High Scores (top 10)")]), _vm._v(" "), _c('div', {
    staticClass: "scores-container"
  }, [_vm._l((_vm.highScores), function(score, index) {
    return _c('div', {
      staticClass: "score-row"
    }, [_c('h2', {
      staticClass: "score-number"
    }, [_vm._v("#" + _vm._s(index + 1))]), _vm._v(" "), _c('div', {
      staticClass: "score-row-details"
    }, [_c('h3', [_vm._v(_vm._s(score.name || 'Anonymous'))]), _vm._v(" "), _c('span', {
      staticClass: "extra-detail"
    }, [_vm._v(_vm._s(score.answerCount) + " / " + _vm._s(score.amount))])])])
  }), _vm._v(" "), (_vm.highScores.length === 0) ? _c('div', [_c('h3', [_vm._v("Loading...")])]) : _vm._e()], 2)])
},staticRenderFns: []}


//////////////////
// WEBPACK FOOTER
// ./~/vue-loader/lib/template-compiler?{"id":"data-v-50fb2485"}!./~/vue-loader/lib/selector.js?type=template&index=0!./src/components/Ranking.vue
// module id = 143
// module chunks = 1